export const environment = {
  production: false,
  baseUrl: 'https://devapi.anikinitek.com/assetmgmtdev/',
  cid: 1793704458230,
  razorpayKey: 'rzp_test_zOmYjCNx9hxf8X'
};

